module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"back-btn":"Retourner aux réglages","page-title":"Modifier un utilisateur","manage-business-title":"Réglages"},"en":{"back-btn":"Back to settings","page-title":"Edit user","manage-business-title":"Réglages"}}')
  delete Component.options._Ctor
}
